import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var EightStep = function EightStep(_ref) {
  var setStep = _ref.setStep,
    closeKYCModal = _ref.closeKYCModal,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    _ref$isPoints = _ref.isPoints,
    isPoints = _ref$isPoints === void 0 ? false : _ref$isPoints;
  var history = router === null || router === void 0 ? void 0 : router.history;
  var handleRedeem = function handleRedeem() {
    closeKYCModal();
    if (history !== null && history !== void 0 && history.push) {
      history.push(isPoints ? "/rewardpointstore" : "/rewardStore", {
        scrollTo: "rewards"
      });
    } else {
      window.location.assign(isPoints ? "/rewardpointstore" : "/rewardStore");
    }
  };
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col items-center justify-center py-3",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "mt-2 font-semibold text-center text-gray-700",
        children: "Your KYC has been completed. You are ready to redeem your rewards."
      }), /*#__PURE__*/_jsx("button", {
        className: "mt-4 bg-primary text-white px-4 py-2 rounded ",
        onClick: handleRedeem,
        children: "REDEEM"
      })]
    })
  });
};
export default EightStep;